export default "__VITE_ASSET__CqRS5hVV__"